import React from 'react';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ size = 'md', showText = true, className = '' }) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  const textSizeClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl',
    xl: 'text-3xl'
  };

  return (
    <div className={`flex items-center ${className}`}>
      {/* Logo Icon - Using the favicon with rounded edges */}
      <div className={`${sizeClasses[size]} rounded-xl overflow-hidden flex-shrink-0`}>
        <img 
          src="/pureblacklogo.png" 
          alt="Certs Logo" 
          className="w-full h-full object-contain"
        />
      </div>
      
      {/* Logo Text */}
      {showText && (
        <span className={`ml-3 ${textSizeClasses[size]} font-bold text-gray-900`}>
          Certs
        </span>
      )}
    </div>
  );
};

export default Logo;
